export default __webpack_public_path__ + "static/media/tempImage.a52b30f4.jpg";